import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetProductReportsService = async (page = 1, limit = 10) => {
  return HTTP_CLIENT.get(
    `${Endpoint.reports.product.get}?page=${page}&limit=${limit}`
  );
};

const DeleteProductReportService = (id: number) => {
  return HTTP_CLIENT.delete(
    `${Endpoint.reports.product.delete.replace(":id", id.toString())}`
  );
};

export { GetProductReportsService, DeleteProductReportService };
